<template>
  <span>
    <!-- モーダル画面 -->
    <div style="display: flex;">
      <!-- アラートダイアログ -->
      <ModalAlertDialog
        :isAlertDialogOpen="isAlertDialogOpen"
        :alertData="alertData"
        @alertResult="alertResult"
      />
    </div>
    <b-modal :active.sync="isReleaseMarkdown" @close="isReleaseMarkdown=false">
      <ReleaseMarkdown />
    </b-modal>
    <b-modal :active.sync="isViewMarkdown" @close="isViewMarkdown=false">
      <ViewMarkdown v-bind:sendnowID="sendID()" :sendvalue="sendValue()" :sendnowDate="sendDate()" :sendreadDate="sendMessage()" :sendtitle="sendTitle()" @contentsMessage="contentsMethod"/>
    </b-modal>
    <ModalRequestHelp></ModalRequestHelp>
    <b-navbar class="topnav">
      <template #brand>
        <b-navbar-item tag="div" style="height: 80px; min-height: 80px; align-items: center; display: flex;">
          <a href="/dashboard/setting/personal" style="width: 80px; height: 80px; display: flex; align-items: center; justify-content: center; background: #222;">
            <img class="account-img" :src="profileImage"/>
          </a>
          <div class="count-bar" v-if="!menuActive">
            現在の訪問者 {{ roomcount }} 名
          </div>
          <div style="margin-left:20px" v-if="user.isAgent && !menuActive">
            <b-button class="release-button" @click="releaseMarkdownModal()">
              <img src="@/assets/template/markdown.png" style="height: 20px; width: 20px;">
            </b-button>
          </div>
          <div style="margin-left:20px;" v-if="!menuActive">
            <b-button class="release-button" @click="viewMarkdownModal()">
              <img src="@/assets/template/notification.png" style="height: 20px; width: 20px;">
              <span class="new-messages"  v-if="messageFlag == true">New!</span>
            </b-button>
          </div>
          <a href="/dashboard" class="hover-item logo">
            <img src="@/assets/logo.svg" style="height: 60px; width: auto; object-fit: cover;">
          </a>
        </b-navbar-item>
        <Search></Search>
        <b-navbar-item tag="div"  style="margin-right: 5px; height: 80px; display: flex; align-items: center; justify-content: center; flex-direction: column;">
          <div style="display: flex; align-items: center; justify-content: center; border-top-right-radius: 0; border-bottom-right-radius: 0;" v-if="user.isAgent">
            <select v-model="currentCompany" class="select"
                    style="font-size: 12px; max-width: 150px; border-top-right-radius: 0; border-bottom-right-radius: 0;"
                    placeholder="select">
              <option
                v-for="(c, index) in companyList"
                :value="c.id"
                :key="index">
                {{ c.name }}
              </option>
            </select>
            <button @click="updateUserCompany(currentCompany)" class="button is-primary" style="font-size: 12px; border-top-left-radius: 0; border-bottom-left-radius: 0;">
              移動
            </button>
          </div>
        </b-navbar-item>
      </template>
      <template #end>
        <b-navbar-item class="hover-item menu-item" @click="setRHModal()" style="color: white;">
          <span class="mdi mdi-comment-question-outline mdi-24px mdi-light"></span>
          お問合わせ
        </b-navbar-item>
        <b-navbar-item class="hover-item menu-item" @click="logout()" style="color: white;">
          <span class="mdi mdi-logout mdi-24px mdi-light"></span>
          ログアウト
        </b-navbar-item>
      </template>
    </b-navbar>
  </span>
</template>

<script>
import { mapState } from 'vuex'
import ModalRequestHelp from '@/components/ui/ModalRequestHelp'
import Search from '@/components/ui/Search'
import ReleaseMarkdown from '../Release/ReleaseMarkdown'
import ViewMarkdown from '../Release/ViewMarkdown'
import Push from 'push.js'
import ModalAlertDialog from '@/components/organisms/common/ModalAlertDialog'
import controlLogMixin from '@/mixins/controlLogMixin'

import {
  /** アラートダイアログ用定義 */
  ALERT_DEF,
  /** アラートダイアログ用データ作成 */
  createAlertData
} from '@/functions/common/alertFunc'

export default {
  name: 'DashBoardNav',
  componentName: 'DashBoardNav',
  components: {
    ModalRequestHelp,
    Search,
    ReleaseMarkdown,
    ViewMarkdown,
    ModalAlertDialog
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    height: {
      type: String,
      default: '0px'
    }
  },
  data () {
    return {
      menuActive: false,
      isChangedCompanyID: false,
      selectCompanyID: '',
      searchWord: '',
      isReleaseMarkdown: false,
      isViewMarkdown: false,
      storageData: {},
      localData: [],
      releaseData: [],
      messageFlag: false,
      messageData: {},
      activeVisitor: [],
      isVisitorInit: false,
      isDeniedCheck: false,
      start: Date.now(),
      executed: false,
      currentCompany: '',
      isAlertDialogOpen: false,
      alertData: {}
    }
  },
  computed: {
    ...mapState('directtalk', ['roomcount', 'roomlist', 'sortFlg', 'filterFlg']),
    ...mapState('chatbot', ['chatbots']),
    ...mapState('auth', ['user', 'isModalRequestHelp', 'companyList']),
    ...mapState("tools",["releaseContents", "draftTexts", "releaseTexts"]),
    profileImage: function () {
      return this.user.profileIcon
    },
  },
  created () {
    console.debug('*** Start *** created')
    this.getCompanyList()
    console.debug('*** End *** created')
  },
  // TODO: ローカライズ始まるまでは一旦切り替えないで日本語固定で
  mounted () {
    window.addEventListener('focus', this.focusIn)
    this.currentCompany = this.user.companyID
    this.$store.dispatch("tools/getText")
    this.localData = []
    this.storageData = JSON.parse(localStorage.getItem('IS_RELEASE_READ') || null)
    if (this.storageData == null) {
      this.storageData = {}
    }
    for (var i = 0; i < Object.keys(this.storageData).length; i++) {
      this.localData.push(this.storageData[i])
    }
    setTimeout(() => {this.handleClick_changeLanguage('ja')}, 2000)
  },
  watch: {
    releaseTexts () {
      this.releaseData=[]
      for (var i = 0; i < this.releaseTexts.length; i++) {
        this.releaseData.push(this.releaseTexts[i].contents_id + "/" + this.getSort(this.releaseTexts[i].updated_at))
      }
      var newMessage=[]
      newMessage = this.releaseData.filter(i => this.localData.indexOf(i) == -1)
      if (newMessage.length == 0) {
        this.messageFlag = false
      } else {
        this.messageFlag = true
      }
    },
    roomcount () {
      let interval = Date.now() - this.start
      if (!this.sortFlg && !this.filterFlg) {
        if (interval > 10000) {
          this.executed = false
          this.getScoutSeeker()
        } else {
          if (!this.executed) {
            setTimeout(this.getScoutSeeker, 10000)
          }
          this.executed = true
        }
      }
      this.start = Date.now()
      // 現在の訪問者数
      if (this.user.isNoticeNewVisitor) {
        // 起動時の訪問者情報取得
        if (!this.isVisitorInit) {
          // 起動時初回は現状の情報を通知処理前に取得しておく
          this.activeVisitor = this.roomlist.active
          this.isVisitorInit = true
        }
        // 通知設定チェック
        if (Push.Permission.get() === Push.Permission.DENIED && !this.isDeniedCheck) {
          // 通知の拒否設定がされていた場合、初回だけメッセージを表示する
          alert('訪問者通知の設定\nHRモンスターからの通知が拒否されています。\nブラウザの設定から通知を許可してください。')
          this.isDeniedCheck = true
          return
        } else if (Push.Permission.get() === Push.Permission.DENIED && this.isDeniedCheck) {
          // 通知拒否チェック済みの場合は何もしないで抜ける
          return
        } else if (Push.Permission.get() !== Push.Permission.GRANTED) {
          // この時点で通知未承認の場合、承認要求を行う
          Push.Permission.request()
        }
        // プッシュ通知
        if (Push.Permission.get() === Push.Permission.GRANTED) {
          // 通知承認済みなら新しい訪問者が来たかチェックする
          let isNewVisitor = false
          for (const room of this.roomlist.active) {
            let isVisiting = false
            for (const visitor of this.activeVisitor) {
              if (room.name === visitor.name) {
                // 現在訪問中の人
                isVisiting = true
                break
              }
            }
            if (!isVisiting) {
              // 新しく来た訪問者
              isNewVisitor = true
              // 1人でも新規の訪問者がいたら通知するので抜ける
              break
            }
          }
          // 現状の訪問者情報を退避
          this.activeVisitor = this.roomlist.active

          // プッシュ通知で表示
          if (isNewVisitor) {
            Push.create('HRモンスターからのお知らせ', {
              body: '新しい訪問者がいらっしゃいました！',
              icon: require('../../assets/lp/logo.png'),
              timeout: 5000,
              onClick: function () {
                window.focus()
                this.close()
              }
            })
          }
        }
      }
    }
  },
  methods: {
    // 検索用のメソッド
    search () {
      var word = this.searchWord.replace(/\s+/g, '')
      if (word == '') {
        // nop
      } else {
        this.$store.dispatch('auth/getSearch', this.searchWord)
      }
    },
    menuToggle () {
      this.menuActive = !this.menuActive
    },
    handleClick_changeLanguage (lang) {
      this.$i18n.locale = lang
    },
    logout () {
      this.$store.dispatch('auth/logout')
        .then(() => {
          return this.sendControlLog('ログアウト', 'ヘッダー右上のログアウトボタンをクリックした。')
        })
        .then(() => {
          this.logoutBar()
        })
    },
    logoutBar () {
      this.$buefy.snackbar.open({
         message: 'ログアウトしました。',
        type: 'is-primary',
        position: 'is-top'
      })
      document.location.href = '/'
    },
    slackTooltip () {
      if (this.homeData.slackCnt != null) {
        return this.homeData.slackCnt
      } else {
        return 0
      }
    },
    selectTooltip () {
      if (this.homeData.selectCnt != null) {
        return this.homeData.selectCnt
      } else {
        return 0
      }
    },
    rate () {
      if (this.homeData.slackCnt > 0 && this.homeData.roomCnt > 0) {
        return Math.round(this.homeData.slackCnt / this.homeData.roomCnt * 100)
      } else {
        return 0
      }
    },
    selectRate () {
      if (this.homeData.selectCnt > 0 && this.homeData.roomCnt > 0) {
        return Math.round(this.homeData.selectCnt / this.homeData.roomCnt * 100)
      } else {
        return 0
      }
    },
    setRHModal () {
      this.$store.dispatch('auth/setRHModal')
    },
    getCompanyList () {
      this.$store.dispatch('auth/getCompanyList')
    },
    updateUserCompany (id) {
      this.$store.dispatch('auth/updateUserCompany', {companyID: id})
    },
    releaseMarkdownModal () {
      this.isReleaseMarkdown = true;
    },
    viewMarkdownModal () {
      this.isViewMarkdown = true;
      this.localData=[]
      this.storageData = JSON.parse(localStorage.getItem('IS_RELEASE_READ') || null)
      if (this.storageData == null) {
        this.storageData = {}
      }
      for (var i = 0; i < Object.keys(this.storageData).length; i++) {
        this.localData.push(this.storageData[i])
      }
    },
    getTimes (time) {
      var ja_time = new Date(time.replace(/-/g, '/').substring(0, 17) + time.substring(25, 29)).toString()
      var new_time = ja_time
        .replace(/Jan/g, '01')
        .replace(/Feb/g, '02')
        .replace(/Mar/g, '03')
        .replace(/Apr/g, '04')
        .replace(/May/g, '05')
        .replace(/Jun/g, '06')
        .replace(/Jul/g, '07')
        .replace(/Aug/g, '08')
        .replace(/Sep/g, '09')
        .replace(/Oct/g, '10')
        .replace(/Nov/g, '11')
        .replace(/Dec/g, '12')
      var get_year = new_time.substring(10,14)
      var get_month = new_time.substring(4,6)
      var get_day = new_time.substring(7,9)
      var get_time = new_time.substring(15,20)
      var dis_time = get_year + '-' + get_month + '-' + get_day + ' ' + get_time
      return dis_time
    },
    getSort (time) {
      var ja_time = new Date(time.replace(/-/g, '/').substring(0, 17) + time.substring(25, 29)).toString()
      var new_time = ja_time
        .replace(/Jan/g, '01')
        .replace(/Feb/g, '02')
        .replace(/Mar/g, '03')
        .replace(/Apr/g, '04')
        .replace(/May/g, '05')
        .replace(/Jun/g, '06')
        .replace(/Jul/g, '07')
        .replace(/Aug/g, '08')
        .replace(/Sep/g, '09')
        .replace(/Oct/g, '10')
        .replace(/Nov/g, '11')
        .replace(/Dec/g, '12')
      var get_year = new_time.substring(10,14)
      var get_month = new_time.substring(4,6)
      var get_day = new_time.substring(7,9)
      var get_hour = new_time.substring(15,17)
      var get_minute = new_time.substring(18,20)
      var dis_time = get_year + get_month + get_day + get_hour + get_minute
      return Number(dis_time)
    },
    sendMessage () {
      var readID = localStorage.getItem('IS_RELEASE_READ')
      var dataDate = []
      var array = []
      var result = []
      var releaseID = 1000000000000
      var contentsID = ""
      for(var i in this.localData) {
        dataDate.push(this.localData[i].slice(-12))
      }
      result = dataDate.filter(function (item) {
        return item.indexOf("undefined")== -1 && item.indexOf("000000000000")== -1
      })
      var sortDataDate = result.sort().pop()
      // console.log("result" + result)

      // 3か月以上前の履歴を削除する場合
      // var jikan = new Date()
      // var now = String(jikan.getFullYear()) + String(jikan.getMonth() + 1) + String(jikan.getDate()) + "0000"
      // console.log(now)

      // var testresult = []

      //   testresult = result.filter(function(item){
      //   return Number(now) - Number(item) < 3000000
      // })
      // console.log(testresult)

      if (readID != null) {
        for (var i in this.releaseTexts) {
          if (this.getSort(this.releaseTexts[i].updated_at) >= sortDataDate) {
            array.push(this.getSort(this.releaseTexts[i].updated_at))
          }
        }
        array.sort(function (a, b) {
          if(a < b) return -1;
          if(a > b) return 1;
          return 0;
        })
        return array[0]
      } else {
        for (var i in this.releaseTexts) {
          if (this.getSort(this.releaseTexts[i].updated_at) < releaseID) {
            releaseID = this.getSort(this.releaseTexts[i].updated_at)
            contentsID = this.releaseTexts[i].contents_id
          }
        }
        this.messageData[Object.keys(this.storageData).length] = contentsID + "/" + releaseID
        return releaseID
      }
    },
    sendID () {
      var sendID = ""
      for (var i in this.releaseTexts) {
        if (this.getSort(this.releaseTexts[i].updated_at) == this.sendMessage()) {
          sendID = this.releaseTexts[i].contents_id
        }
      }
      return sendID
    },
    sendValue () {
      var sendValue = ""
      for (var i in this.releaseTexts) {
        if (this.getSort(this.releaseTexts[i].updated_at) == this.sendMessage()) {
          sendValue = this.releaseTexts[i].contents
        }
      }
      return sendValue
    },
    sendDate(){
      var sendDate = ""
      for (var i in this.releaseTexts) {
        if (this.getSort(this.releaseTexts[i].updated_at) == this.sendMessage()) {
          sendDate = this.getTimes(this.releaseTexts[i].updated_at)
        }
      }
      return sendDate
    },
    sendTitle () {
      var sendTitle = ""
      for (var i in this.releaseTexts)
        if (this.getSort(this.releaseTexts[i].updated_at) == this.sendMessage()) {
          sendTitle = this.releaseTexts[i].title
      }
      return sendTitle
    },
    getScoutSeeker () {
      return
      // this.$store.dispatch('directtalk/getSeeker', 'scout')
    },
    contentsMethod () {
      this.localData=[]
      this.storageData = JSON.parse(localStorage.getItem('IS_RELEASE_READ') || null)
      if (this.storageData == null) {
        this.storageData = {}
      }
      for (var i = 0; i < Object.keys(this.storageData).length; i++) {
        this.localData.push(this.storageData[i])
      }
    },
    alertResult (alertResultData) {
      if (alertResultData) {
        if (alertResultData.alertKeyFunction === 'client-nav') {
          if (alertResultData.alertKeyWord === 'reload-alert') {
            this.isAlertDialogOpen = false
            // リロードしてダッシュボードへ
            location.href = '/dashboard'
          }
        }
      }
    },
    focusIn () {
      // 現在の会社IDを取得
      const afterCompany = localStorage.getItem('_user_c')
      if (this.user.companyID !== afterCompany) {
        // 別のタブかウィンドウで会社が変更されていたらアラートを出してリロードする
        this.alertData = createAlertData(
          '会社変更リロード',
          '他のタブかウィンドウで会社が変更されました。\nリロードします。',
          ALERT_DEF.MESSAGE_INFO,
          ALERT_DEF.DIALOG_ALERT,
          'client-nav',
          'reload-alert'
        )
        this.isAlertDialogOpen = true
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('focus', this.focusIn)
  }
}
</script>
<style scoped>
.signup {
  font-weight: 900;
}
.topnav {
  background: #222;
  color: white;
  height:     80px;
  min-height: 80px;
  max-height: 80px;
  margin: 0 !important;
  font-size: 14px;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.account-img {
  width:  50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  background: white;
}
.bar-menu {
  background: #222;
  color: white;
}
.count-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  border: solid thin #AA0066;
  font-size: 16px;
  border-radius: 7.5px;
  height: 50px;
  color: white;
}
.logo {
  margin-left: calc(50vw - 500px);
  width: 200px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 1024px) {
  .logo {
    margin-left: 0px;
  }
}
.hover-item {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
}
.menu-item {
  flex-wrap: wrap;
  width: 100px;
}
.hover-item:hover {
  background-color:rgba(150, 140, 140, 0.8) !important;
}

.release-button {
  /* padding:0; */
  border:none; 
  background: #212121;
}

.new-messages{
 position: absolute;
 font-size:80%;
 padding: 0px 5px;
 color: #ffffff; /* 文字色 */
 background: rgb(214, 24, 81); /* 背景色 */
 
 border-radius: 8px;
 animation: flash 1.5s linear infinite;
}
@keyframes flash {
  0%,100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

.topnav >>> .navbar-item img {
  max-height: none;
}

.topnav >>> .navbar-menu.is-active {
  background: #222;
  margin-left: calc(100% - 220px);
}

.topnav >>> .navbar-menu.is-active .navbar-end {
  display: flex;
  justify-content: flex-end;
}

.topnav >>> .navbar-burger {
  margin-top: 16px;
  margin-right: 16px;
  color: white;
}
.topnav >>> .navbar-burger span {
  height: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DashBoardNav.vue